export const isNullOrEmptyString = (str: string) => (!str || /^\s*$/.test(str));
